<template>
  <div class="modal-body">
    <div class="container">
      <div class="gridPhoto">
        <div class="card border-success mb-4 shadow-lg">
          <!-- Preview de IMG -->
          <div class="image-preview" v-if="imageData[0] != undefined">
            <img
              class="container"
              :src="`${imageData[0]}`"
              id="fotoEmbalagemPreview"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
              @click="clickPreview(imageData[0])"
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              id="fotoEmbalagemPreview"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>
          <!--  -->

          <div class="card-body flex-column">
            <p class="card-text">Foto da embalagem externa</p>
            <div class="icons" v-if="configInputs == 0">
              <div class="btn-group">
                <label class="palavra" for="fotoEmbalagem"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>

                <input
                  type="file"
                  id="fotoEmbalagem"
                  @change="previewFiles($event, 0)"
                  multiple
                />

                <label
                  class="palavra"
                  @click="resetFile(0)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <img src="" alt="">
          <!-- Preview de IMG -->
          <div class="image-preview" v-if="imageData[1] != undefined">
            <img
              class="container"
              :src="`${imageData[1]}`"
              id="fotoEmbalagemPreview"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
              @click="clickPreview(imageData[1])"
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              id="fotoEmbalagemPreview"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>
          <!--  -->

          <div class="card-body flex-column">
            <p class="card-text">Foto da embalagem interna</p>
            <div class="icons"  v-if="configInputs == 0">
              <div class="btn-group">
                <label class="palavra" for="img-outrasFotosAbertura"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>
                <input
                  type="file"
                  id="img-outrasFotosAbertura"
                  @change="previewFiles($event, 1)"
                  multiple
                />

                <label
                  class="palavra"
                  @click="resetFile(1)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-success mb-4 shadow-lg">
          <!-- Preview de IMG -->
          <div class="image-preview" v-if="imageData[2] != undefined">
            <img
              class="container"
              :src="`${imageData[2]}`"
              @click="clickPreview(imageData[2])"
              id="fotoEmbalagemPreview"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>

          <div class="image-preview" v-else>
            <img
              src="img/foto.svg"
              id="fotoEmbalagemPreview"
              class="container"
              width="195"
              height="210"
              alt=""
              border="0"
              align=""
            />
          </div>
          <!--  -->

          <div class="card-body">
                    <div v-if="configInputs == 0">
                <p class="card-text">Extra</p>
             </div>
             <div v-else>

        <p class="card-text" v-if="!FormDataImages.fotoEmbalgemExtra.description">Extra</p>
              <p class="card-text" v-else>{{FormDataImages.fotoEmbalgemExtra.description}}</p>
            
             </div>
            

            <div class="icons flex-column" v-if="configInputs == 0">

              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="FormDataImages.fotoEmbalgemExtra.description"
                />
              </div>

              <div class="btn-group">
                <label class="palavra" for="img-outrasFotosAbertura2"
                  ><i class="fas fa-camera" aria-hidden="true"></i
                ></label>
                <input
                  type="file"
                  id="img-outrasFotosAbertura2"
                  @change="previewFiles($event, 2)"
                  multiple
                />
                <label
                  class="palavra"
                  @click="resetFile(2)"
                  style="background-color: red"
                  ><i class="fa fa-trash" aria-hidden="true"></i
                ></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },

  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      fotoEmbalagem: [],
      imageData: [],
      FormDataImages: {
        fotoEmbalagemE: [],
        fotoEmbalagemI: [],
        fotoEmbalgemExtra: {
          file: [],
          description: "",
        },
      },
    };
  },
  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesAberturaEmbalagem", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal.fire({
        imageUrl: base64,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXT) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` + `${dataQuery.ImagesRRIM[0].IMG_EMB_EXT}`;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_INT) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` + `${dataQuery.ImagesRRIM[0].IMG_EMB_INT}`;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA}`;
      }

         if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC) {
           this.FormDataImages.fotoEmbalgemExtra.description =
          dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC ;
      }
    },
    previewFiles(event, position) {
      // Referência ao elemento de entrada DOM
      var input = event.target;
      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        //Identificando em qual contexto a imagem se encaixa
        switch (position) {
          case 0:
            this.FormDataImages.fotoEmbalagemE = input.files[0];
            break;
          case 1:
            this.FormDataImages.fotoEmbalagemI = input.files[0];
            break;
          case 2:
            this.FormDataImages.fotoEmbalgemExtra.file = input.files[0];
            break;
        }

        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },
    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.fotoEmbalagemE = [];
          break;
        case 1:
          this.FormDataImages.fotoEmbalagemI = [];
          break;
        case 2:
          this.FormDataImages.fotoEmbalgemExtra.file = [];
          this.FormDataImages.fotoEmbalgemExtra.description = "";
          break;
      }

      // this.$emit("setFotosAbertEmb",this.FormDataImages)
    },
  },
};
</script>

<style scoped>
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-body .container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  width: 100%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.modal-body .container .gridPhoto {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

/* .modal-body .container .gridPhoto {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
} */

.modal-body .container .gridPhoto .card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid var(--cinza);
  border-radius: 0.35rem;
}

.modal-body .container .gridPhoto .border-success {
  border-color: var(--green);
}

.modal-body .container .gridPhoto .mb-4 {
  margin-bottom: 1.5rem;
}

.modal-body .container .gridPhoto .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.modal-body .container .gridPhoto .card img {
  vertical-align: middle;
  border-style: none;
}

.modal-body .container .gridPhoto .card .card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.modal-body .container .gridPhoto .card .card-body p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.modal-body .container .gridPhoto .card .card-body .icons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group .palavra {
  background-color: var(--blue);
  border-radius: 5px;
  color: var(--white);
  cursor: pointer;
  margin: 10px;
  padding: 6px 10px;
}

.modal-body .container .gridPhoto .card .card-body .icons .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.modal-body .container .gridPhoto .card .card-body .icons .btn-group input {
  overflow: visible;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.modal-body
  .container
  .gridPhoto
  .card
  .card-body
  .icons
  .btn-group
  input[type="file"] {
  display: none;
}

.flex-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.card-text {
  font-size: 0.8rem;
  font-weight: 700;
}

*,
::after,
::before {
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1140px;
  }
}

@media (min-width: 768px) {
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 32%;
  }
}

@media (max-width: 425px) {
  .modal-body .container .gridPhoto {
    grid-template-columns: 1fr;
  }
  .modal-body .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding: 0;
  }
}
</style>
